import { useState } from 'react'
import logger from '../logger'

interface useLocalStorageProps {
    key: string
    initialValue: string
}

export function useLocalStorage({ key, initialValue }: useLocalStorageProps) {
    const [storedValue, setStoredValue] = useState(() => {
        if (typeof window === 'undefined') {
            return initialValue
        }

        try {
            const item = window.localStorage.getItem(key)
            return item ? JSON.parse(item) : initialValue
        } catch (err) {
            if (err instanceof Error) {
                logger.error(
                    { err },
                    'useLocalStorage getItem error, using initialValue',
                )
            } else {
                logger.error(
                    { error: String(err) },
                    'useLocalStorage getItem error, using initialValue',
                )
            }
            return initialValue
        }
    })

    const setValue = (value: any) => {
        try {
            const valueToStore =
                value instanceof Function ? value(storedValue) : value

            setStoredValue(valueToStore)
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(valueToStore))
            }
        } catch (err) {
            if (err instanceof Error) {
                logger.error({ err }, 'useLocalStorage setItem error')
            } else {
                logger.error(
                    { error: String(err) },
                    'useLocalStorage setItem error',
                )
            }
        }
    }
    return [storedValue, setValue]
}
